import type { ForceResultWithFullResponse, IFetchService, PostConfigObject } from "app/services/fetchService";

import type { CreateThreadResponse, LeadGeneratorAgentMessagePayload, LeadGeneratorThreadData } from "../../types/dto";

const DEFAULT_URL = "sales-api/ai-leads-generator-agent";
const THREADS_URL = `${DEFAULT_URL}/threads`;

export default function createLeadGeneratorAgentApiService(apiClient: IFetchService) {
    return {
        createAIAgentThread: (options?: Readonly<PostConfigObject>): Promise<CreateThreadResponse | null> => {
            return apiClient.post(THREADS_URL, {}, options);
        },

        postAIAgentMessage: (
            { threadId, ...payload }: LeadGeneratorAgentMessagePayload,
            options?: Readonly<PostConfigObject>,
        ): Promise<ForceResultWithFullResponse<LeadGeneratorThreadData>> => {
            return apiClient.post(`${THREADS_URL}/${threadId}/message`, payload, options);
        },
    };
}
